import React, { useEffect, useState } from "react";
import { getBlogs, deleteBlog } from "../../api/BlogService";
import { getErrorMessage } from "../../utils/errorHandler";
import { useNavigate } from "react-router-dom";
import Pagination from "../Pagination/Pagination";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import StatusBadge from "../Shared/StatusBadge";
import ActionIconButton from "../Shared/ActionIconButton";
import FullPageLoader from "../../common/FullPageLoader";
import EmptyState from "../../common/EmptyState";
export default function Blog() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const loadData = async () => {
    try {
      setLoading(true);
      const res = await getBlogs(currentPage, itemsPerPage);
      const data = Array.isArray(res?.data) ? res.data : [];
      const pagination = res?.pagination || {};
      setList(data);
      setTotalItems(
        pagination?.totalItems || pagination?.totalitems || pagination?.total || data.length || 0,
      );
      setErrorMessage("");
    } catch (err) {
      console.error("Failed to fetch blogs:", err);
      setErrorMessage(getErrorMessage(err));
      setList([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadData();
  }, [currentPage]);
  if (loading) {
    return <FullPageLoader text="Loading Blogs..." />;
  }

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this blog?");

    if (!confirmDelete) return;

    try {
      const res = await deleteBlog(id);

      if (res.success) {
        // remove deleted item from UI
        setList((prev) => prev.filter((item) => item._id !== id));
      }
    } catch (error) {
      console.error("Delete Error:", error);

      setErrorMessage(error?.response?.data?.message || "Failed to delete blog");
    }
  };

  return (
    <div className="container-fluid p-4 np-blog-page">

      {/* HEADER */}
      <div className="card p-3">
        {list.length === 0 ? (
          <EmptyState
            action={
              <button
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={() => navigate("/blog/add")}
              >
                <FaPlus /> Add Blog
              </button>
            }
          />
        ) : (
          <>
      <div className="d-flex justify-content-end align-items-center pb-3">
        <button
          className="btn btn-primary d-flex align-items-center gap-2"
          onClick={() => navigate("/blog/add")}
        >
          <FaPlus />
          Add Blog
        </button>
      </div>
      {/* TABLE */}
     
        <div className="table-responsive">
          <table
            className="table table-bordered table-hover"
            style={{
              borderColor: "#dee2e6",
            }}
          >
            <thead className="bg-light">
              <tr>
                <th className="text-dark fw-bold">#</th>
                <th className="text-dark fw-bold">Title</th>
                <th className="text-dark fw-bold">Category</th>
                <th className="text-dark fw-bold">Read Time</th>
                <th className="text-dark fw-bold">Status</th>
                <th className="text-dark fw-bold text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => (
                  <tr key={item._id || index}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>
                      <div className="fw-semibold">{item.title || "-"}</div>
                      <small className="text-muted">{item.blogDescription || "-"}</small>
                    </td>
                    <td>{item.category?.name || "-"}</td>
                    <td>{item.readingTime ? `${item.readingTime} min` : "-"}</td>
                    <td>
                      <StatusBadge status={item.status} />
                    </td>
                    <td className="text-center">
                      <div className="d-flex justify-content-center align-items-center np-table-actions">
                        <ActionIconButton
                          icon={<FaEye />}
                          label="View"
                          variant="view"
                          onClick={() => navigate(`/blog/view/${item.seo?.slug}`)}
                        />

                        <ActionIconButton
                          icon={<FaEdit />}
                          label="Edit"
                          variant="edit"
                          onClick={() =>
                            navigate(`/blog/edit/${item.seo?.slug}`, {
                              state: {
                                blogId: item._id,
                                blogslug: item.seo?.slug,
                              },
                            })
                          }
                        />

                        <ActionIconButton
                          icon={<FaTrash />}
                          label="Delete"
                          variant="delete"
                          onClick={() => handleDelete(item._id)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
          </>
        )}
      </div>
      {/* PAGINATION */}
      {list.length > 0 && <Pagination
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
      />}
    </div>
  );
}
